module.exports = __webpack_public_path__ + "img/bidding-lock.f1b93b31.png";